(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp-card-hover-video"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.spCardHover) return;
    window.spCardHover = true;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    function start(gallery) {
      var video = gallery.querySelector('video[data-sp-hover-video]');
      if (!video) return;
      if (!video.getAttribute('src')) video.setAttribute('src', video.dataset.src);
      video.muted = true;
      try { video.currentTime = 0; } catch (e) {}
      video.addEventListener('playing', function () {
        if (gallery.dataset.spHover === '1') gallery.classList.add('sp-video-on');
      }, { once: true });
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    }

    function stop(gallery) {
      gallery.classList.remove('sp-video-on');
      var video = gallery.querySelector('video[data-sp-hover-video]');
      if (video) video.pause();
    }

    document.addEventListener('pointerover', function (event) {
      if (!canHover.matches || !(event.target instanceof Element)) return;
      var gallery = event.target.closest('.card-gallery');
      if (!gallery || gallery.dataset.spHover === '1') return;
      gallery.dataset.spHover = '1';
      start(gallery);
    }, { passive: true });

    document.addEventListener('pointerout', function (event) {
      if (!(event.target instanceof Element)) return;
      var gallery = event.target.closest('.card-gallery');
      if (!gallery || gallery.dataset.spHover !== '1') return;
      if (event.relatedTarget instanceof Node && gallery.contains(event.relatedTarget)) return;
      gallery.dataset.spHover = '';
      stop(gallery);
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
